export interface AssetID {
    year : number;
    month : number;
    date : number;
    showCode : string;
    extra : string;
    strDate: string;
    string : string;
}

export class Asset {
    static readonly REGEX = /^(\d\d)(\d\d)(\d\d)__([^\d]+)(.*)$/;

    public static parseID(str : string): AssetID {
        let match = str.match(this.REGEX);
        if (!match)
            throw new Error(`Cannot parse asset ID '${str}'`);

        return {
            year: parseInt(match[1]),
            month: parseInt(match[2]),
            date: parseInt(match[3]),
            showCode: match[4],
            extra: match[5],
            strDate: `20${ match[1] }-${ match[2] }-${ match[3] }`,
            string: str
        };
    }

    public static validID(str: string): boolean {
        return this.REGEX.test(str);
    }
}
